module.exports = ".details {\r\n    padding-left: 40px !important;\r\n}\r\n\r\n.details-title {\r\n    padding-left: 30px !important;\r\n}\r\n\r\n#btnContainer {\r\n    margin-top: 22px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/salaries/salary-report/salary-report.component.css
// module id = ./src/app/components/salaries/salary-report/salary-report.component.css
// module chunks = main